<div class="second-content">
  <div class="second-table1">
    <nz-table #table1Table [nzData]="listOfTable1Data" [nzShowPagination]="false" nzTableLayout="fixed">
      <thead>
        <tr>
          <th nzWidth="4%" scope="col">{{ 'BidCreat.Item' | translate }}</th>
          <th nzWidth="34%" scope="col">{{ 'BidCreat.ProjectName' | translate }}</th>
          <th nzWidth="29%" scope="col">{{ 'BidCreat.Proportion' | translate }}</th>
          <th nzWidth="4%" scope="col">{{ 'BidCreat.Unit' | translate }}</th>
          <th nzWidth="5%" scope="col">{{ 'BidCreat.Quantity' | translate }}</th>
          <th nzWidth="14%" scope="col">{{ 'BidCreat.TotalPriceWithTax' | translate }}</th>
          <th nzWidth="10%" scope="col">{{ 'BidCreat.Remark' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data1 of table1Table.data; let i = index">
          <ng-container *ngIf="data1.id; else elseTemplate">
            <td>{{ data1.id }}</td>
            <td>{{ data1.projectName }}</td>
            <td>
              <ng-container
                *ngIf="(makeBidEditStatus || editBudgetEstimatesStatus) && !reviewResultIsReject; else elseDefaultScale">
                <nz-input-number *ngIf="data1.scaleNumber>=0" [(ngModel)]="data1.scaleNumber"
                  (ngModelChange)="nzTable1ScaleChanged($event,i)" [nzMin]="0" [nzMax]="100" [nzStep]="1"
                  nzPrecision="2" [nzFormatter]="formatterPercent" [nzParser]="parserPercent" nzBorderless>
                </nz-input-number>
              </ng-container>
              <ng-template #elseDefaultScale>
                {{ data1.scale }}
              </ng-template>
            </td>
            <td>{{ data1.unit }}</td>
            <td>{{ data1.quantity }}</td>
            <ng-container *ngIf="produceBudgetStatus && i===0;else elseTemplate1">
              <td style="color: #7cb8bd;">{{ table2TotalPrice }}</td>
            </ng-container>
            <ng-template #elseTemplate1>
              <ng-container *ngIf="produceBudgetStatus && i===1;else elseTemplate2">
                <td style="color: #7cb8bd;">{{ profitTotalPrice }}</td>
              </ng-container>
              <ng-template #elseTemplate2>
                <ng-container *ngIf="produceBudgetStatus && i===2;else elseTemplate3">
                  <td style="color: #7cb8bd;">{{ taxRatesTotalPrice }}</td>
                </ng-container>
                <ng-template #elseTemplate3>
                  <td>-</td>
                </ng-template>
              </ng-template>
            </ng-template>

            <!-- 备注 -->
            <ng-container
              *ngIf="(makeBidEditStatus || editBudgetEstimatesStatus) && !reviewResultIsReject; else elseTemplate4">
              <td>
                <input nz-input nz-tooltip nzBorderless nzSize="small" [nzTooltipTitle]="data1.remark"
                  nzTooltipPlacement="topRight" [(ngModel)]="data1.remark"
                  (ngModelChange)="nzTable1RemarkChanged($event,i)">
              </td>
            </ng-container>
            <ng-template #elseTemplate4>
              <td>{{ data1.remark }}</td>
            </ng-template>
          </ng-container>
          <ng-template #elseTemplate>
            <td colspan="3">{{ data1.projectName }}</td>
            <td>{{ data1.unit }}</td>
            <td>{{ data1.quantity }}</td>
            <ng-container *ngIf="produceBudgetStatus;else elseTemplate5">
              <td style="color: #7cb8bd; font-weight: bold;">{{ table1TotalPrice }}</td>
            </ng-container>
            <ng-template #elseTemplate5>
              <td>-</td>
            </ng-template>
            <td></td>
          </ng-template>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div class="second-table2">
    <nz-table #table2 [nzData]="listOfBaseMaterialData" [nzShowPagination]="false" nzTableLayout="fixed">
      <thead>
        <tr>
          <th nzWidth="4%" scope="col">{{ 'BidCreat.Item' | translate }}</th>
          <th nzWidth="9%" scope="col">{{ 'BidCreat.PN' | translate }}</th>
          <th nzWidth="8%" scope="col">{{ 'BidCreat.PrimaryCategory' | translate }}</th>
          <th nzWidth="9%" scope="col">{{ 'BidCreat.SecondaryCategory' | translate }}</th>
          <th nzWidth="8%" scope="col">{{ 'BidCreat.MinorCategory' | translate }}</th>
          <th nzWidth="9%" scope="col">{{ 'BidCreat.ProjectName' | translate }}</th>
          <th nzWidth="7%" scope="col">{{ 'BidCreat.BrandOrigin' | translate }}</th>
          <th nzWidth="13%" scope="col">{{ 'BidCreat.SpecModel' | translate }}</th>
          <th nzWidth="4%" scope="col">{{ 'BidCreat.Unit' | translate }}</th>
          <th nzWidth="5%" scope="col">{{ 'BidCreat.Quantity' | translate }}</th>
          <th nzWidth="7%" scope="col">{{ 'BidCreat.UntaxedUnitPrice' | translate }}</th>
          <th nzWidth="7%" scope="col">{{ 'BidCreat.UntaxedTotalPrice' | translate }}</th>
          <th nzWidth="10%" scope="col">{{ 'BidCreat.Remark' | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data2 of table2.data;let i = index">
          <tr class="table2-tr">
            <ng-container class="table2-row1"
              *ngIf="(makeBidEditStatus || editBudgetEstimatesStatus) && !reviewResultIsReject; else elseTemplate">
              <td colSpan="13">
                <div class="div-input" style="width: 100%;height: 100%; float: left;">
                  <input type="text" nz-input style="text-align: left;padding-left: 5px;" [(ngModel)]="data2['item']"
                    (ngModelChange)="ngItemChange($event,i)" placeholder="{{ 'BidCreat.CategoryItemNote' | translate }}"
                    nzSize="small">
                </div>
              </td>
              <!-- 添加分类项次,删除分类项次 -->
              <div class="table2-button1">
                <em nz-icon nzType="plus-circle" nzTheme="twotone" (click)="addlist(i)"></em>
                <em nz-icon nzType="minus-circle" nzTheme="twotone" (click)="dellist(i)"></em>
              </div>
            </ng-container>
            <ng-template #elseTemplate>
              <td colSpan="13" style="text-align: left;padding-left: 5px;">{{ data2['item'] }}</td>
            </ng-template>
          </tr>
          <ng-container class="table2-othersrow" *ngIf="data2['itemDetail']">
            <ng-container *ngFor="let item of data2['itemDetail']; let j = index">
              <tr class="table2-tr">
                <td>{{ j+1 }}</td>
                <ng-container
                  *ngIf="(makeBidEditStatus || editBudgetEstimatesStatus) && !reviewResultIsReject; else elseTemplate1">
                  <td>{{ item.pn }}</td>
                  <!-- 因为在新增清单或者新增行时, item.baseMaterialData是异步产生的,可能会出现子组件运行完毕但是item.baseMaterialData还没有产生就会报错 -->
                  <ng-container *ngIf="item['baseMaterialData']">
                    <td *ngFor="let selectOption of selectColumns">
                      <nz-select nzAllowClear [nzOptionOverflowSize]=5 nzPlaceHolder="" [(ngModel)]="item[selectOption]"
                        (ngModelChange)="ngSelectChange($event,selectOption,listOfBaseMaterialData,i,j)">
                        <nz-option *ngFor="let selectItem of item['baseMaterialData'][selectOption]"
                          [nzLabel]="selectItem" [nzValue]="selectItem">
                        </nz-option>
                      </nz-select>
                    </td>
                    <td>{{ item.unit }}</td>
                    <td>
                      <input type="text" [(ngModel)]="item.quantity"
                        (ngModelChange)="ngSelectChange($event,'quantity',listOfBaseMaterialData,i,j)" nz-input
                        nzSize="small">
                    </td>
                    <ng-container *ngIf="produceBudgetStatus; else elseTemplate2">
                      <td style="color: #7cb8bd;">{{ item.notInUnitPrice }}</td>
                    </ng-container>
                    <ng-template #elseTemplate2>
                      <td>-</td>
                    </ng-template>
                    <ng-container *ngIf="produceBudgetStatus; else elseTemplate3">
                      <td style="color: #7cb8bd;">{{ item.notInTotalPrice }}</td>
                    </ng-container>
                    <ng-template #elseTemplate3>
                      <td>-</td>
                    </ng-template>
                    <td>
                      <input nz-input nzSize="small" nz-tooltip [nzTooltipTitle]="item.remark"
                        nzTooltipPlacement="topRight" [(ngModel)]="item.remark">
                    </td>
                    <!-- 添加行,删除行 -->
                    <div class="table2-button2">
                      <em nz-icon nzType="plus-circle" nzTheme="twotone" (click)="addrow(i,j)"></em>
                      <em nz-icon nzType="minus-circle" nzTheme="twotone" (click)="delrow(i,j)"></em>
                    </div>
                  </ng-container>
                </ng-container>
                <!-- 概算已制定后,一般工程要显示价格 -->
                <ng-template #elseTemplate1>
                  <ng-container *ngFor="let table2Column of table2Columns">
                    <ng-container
                      *ngIf="(table2Column ==='notInUnitPrice' || table2Column ==='notInTotalPrice') ;else elseTemplate4">
                      <ng-container *ngIf="produceBudgetStatus;else elseTemplateTable2">
                        <td style="color: #7cb8bd;">{{ item[table2Column] }}</td>
                      </ng-container>
                      <ng-template #elseTemplateTable2>
                        <td>-</td>
                      </ng-template>
                    </ng-container>
                    <ng-template #elseTemplate4>
                      <td>{{ item[table2Column] }}</td>
                    </ng-template>
                  </ng-container>
                </ng-template>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- total行 -->
        <ng-container>
          <tr>
            <td colSpan="11" style="text-align: right; padding-right: 2.3%;">Total</td>
            <ng-container *ngIf="produceBudgetStatus;else elseTemplate5">
              <td style="color: #7cb8bd; font-weight: bold;">{{ table2TotalPrice }}</td>
            </ng-container>
            <ng-template #elseTemplate5>
              <td>-</td>
            </ng-template>
            <td></td>
          </tr>
        </ng-container>
        <!-- 备注  盖章处 -->
        <ng-container>
          <tr>
            <td colSpan="9">
              <div class="remark">
                <div>
                  <p>{{ 'BidCreat.Remark' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark1' | translate }}</p>
                </div>
                <div class="monthlyDay">
                  <p>{{ 'BidCreat.Remark2-1' | translate }}</p>
                  <ng-container *ngIf="makeBidEditStatus; else elseTemplate6">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                  </ng-container>
                  <ng-template #elseTemplate6>
                    <ng-container *ngIf="makeBudgetEstimatesStatus && editBudgetEstimatesStatus; else elseTemplate7">
                      <nz-select nzBorderless nzShowArrow nzSize="small" [(ngModel)]="bidBaseInfor['monthlyDay']"
                        (ngModelChange)="ngRemarkSelectChange($event,'monthlyDay')" [nzOptions]="monthlyDaysOption">
                      </nz-select>
                    </ng-container>
                    <ng-template #elseTemplate7>
                      <p class="value">&nbsp;{{ bidBaseInfor['monthlyDay'] }}&nbsp;</p>
                    </ng-template>
                  </ng-template>
                  <p>{{ 'BidCreat.Remark2-2' | translate }}</p>
                </div>
                <div class="warrantyPeriod">
                  <p>{{ 'BidCreat.Remark3' | translate }}&nbsp;</p>
                  <ng-container *ngIf="makeBidEditStatus; else elseTemplate8">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                  </ng-container>
                  <ng-template #elseTemplate8>
                    <ng-container *ngIf="makeBudgetEstimatesStatus && editBudgetEstimatesStatus; else elseTemplate9">
                      <nz-select nzBorderless nzShowArrow nzSize="small" [(ngModel)]="bidBaseInfor['warrantyPeriod']"
                        (ngModelChange)="ngRemarkSelectChange($event,'warrantyPeriod')"
                        [nzOptions]="warrantyPeriodsOption">
                      </nz-select>
                    </ng-container>
                    <ng-template #elseTemplate9>
                      <p class="value">{{ bidBaseInfor['warrantyPeriod'] }}</p>
                    </ng-template>
                  </ng-template>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark4' | translate }}</p>
                </div>
                <div class="deliveryCycle">
                  <p>{{ 'BidCreat.Remark5-1' | translate }}</p>
                  <ng-container *ngIf="makeBidEditStatus; else elseTemplate10">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                  </ng-container>
                  <ng-template #elseTemplate10>
                    <ng-container *ngIf="editBudgetEstimatesStatus; else elseTemplate11">
                      <input type="text" nz-input [(ngModel)]="bidBaseInfor['deliveryCycle']"
                        (ngModelChange)="ngRemarkSelectChange($event,'deliveryCycle')" nzSize="small">
                    </ng-container>
                    <ng-template #elseTemplate11>
                      <p class="value">{{ bidBaseInfor['deliveryCycle'] }}</p>
                    </ng-template>
                  </ng-template>
                  <p>{{ 'BidCreat.Remark5-2' | translate }}</p>
                </div>
                <div class="quoteInday">
                  <p>{{ 'BidCreat.Remark6' | translate }}</p>
                  <ng-container *ngIf="makeBidEditStatus; else elseTemplate12">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                  </ng-container>
                  <ng-template #elseTemplate12>
                    <ng-container *ngIf="editBudgetEstimatesStatus; else elseTemplate13">
                      <nz-select nzBorderless nzShowArrow nzSize="small" [(ngModel)]="bidBaseInfor['quoteInday']"
                        (ngModelChange)="ngRemarkSelectChange($event,'quoteInday')" [nzOptions]="quoteIndaysOption">
                      </nz-select>
                    </ng-container>
                    <ng-template #elseTemplate13>
                      <p class="value">&nbsp;{{ bidBaseInfor['quoteInday'] }}&nbsp;</p>
                    </ng-template>
                  </ng-template>
                  <p>{{ 'BidCreat.Days' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark7' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark8' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark8-1' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark8-2' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark8-3' | translate }}</p>
                </div>
                <div>
                  <p>{{ 'BidCreat.Remark8-4' | translate }}</p>
                </div>
              </div>
            </td>
            <td colSpan="4">
              <p style="float: left; padding-left: 5px;">{{ 'BidCreat.Stamp' | translate }}</p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
  <!-- 标单third-content -->
  <div class="third-content">
    <p>No.:20190322V1</p>
  </div>
  <!-- 一般工程显示预算编码和挂账部门,专案工程无 -->
  <div class="inquotationInfo" *ngIf="step >= 10 && getProjectCategory === 0 ">
    <div>
      <span style="color: red;">*</span>
      <span>{{ 'ReviewResult.BudgetCode' | translate }}:</span>
      <span *ngIf="getFormBudgetCharge !== undefined" style="margin-left: 5px;">
        {{ getFormBudgetCharge['budgetCode'] }}
      </span>
    </div>
    <div>
      <span style="color: red;">*</span>
      <span>{{ 'ReviewResult.CreditDept' | translate }}:</span>
      <span *ngIf="getFormBudgetCharge !== undefined" style="margin-left: 5px;">
        {{ getFormBudgetCharge['creditDepartment'] }}
      </span>
    </div>
    <div>
      <span style="color: red;">*</span>
      <span>{{ 'ReviewResult.CreditPlant' | translate }}:</span>
      <span *ngIf="getFormBudgetCharge !== undefined" style="margin-left: 5px;">
        {{ getFormBudgetCharge['plant'] }}
      </span>
    </div>
  </div>